import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) {}

  public GetAgendamentoFilter(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportAgendamentosFilter`;

    return this.http.get<any>(url);
  }

  public GetPreco(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportPrecos`;

    return this.http.get<any>(url);
  }

  public GetEmpresa(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportEmpresas`;

    return this.http.get<any>(url);
  }

  public GetEntradaGate(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportGateEntradas`;

    return this.http.get<any>(url);
  }
}
